var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"uik-table-cell",class:{
        'uik-table-cell__sticky': _vm.sticky,
        'uik-table-cell__hide--desktop-small': _vm.hide === 'd',
        'uik-table-cell__hide--tablet': _vm.hide === 't',
        'uik-table-cell__hide--mobile': _vm.hide === 'm',
        'uik-table-cell__seamless': _vm.type === 'seamless',
        'uik-table-cell--loading': _vm.isLoading
    }},[_c('div',{staticClass:"uik-table-cell__container"},[(_vm.isLoading)?_c('UikLoader',{staticClass:"uik-table-cell__loader",attrs:{"type":"dots","color":"primary","size":0.45}}):_vm._e(),_c('div',{staticClass:"uik-table-cell__content",class:{
                'uik-table-cell__align--center': _vm.align === 'center',
                'uik-table-cell__align--right': _vm.align === 'right',
                'uik-table-cell__align--around': _vm.align === 'around',
                'uik-table-cell__align--between': _vm.align === 'between',
                'uik-table-cell__align--even': _vm.align === 'even',
                'uik-table-cell__text--small': _vm.isStyle('small'),
                'uik-table-cell__text--base': _vm.isStyle('base'),
                'uik-table-cell__text--fade': _vm.isStyle('fade'),
                'uik-table-cell__text--code': _vm.isStyle('code'),
                'uik-table-cell__text--bold': _vm.isStyle('bold'),
                'uik-table-cell__text--primary': _vm.isStyle('primary'),
                'uik-table-cell__text--nowrap': _vm.isStyle('nowrap'),
                'uik-table-cell__avatars': _vm.type === 'avatars'
            }},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }